/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    take, fork, call, put, select,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';

import { getCalculateDynamicPassport } from '../../../Passport/Passport-Action';
import {
    getAppliedPromotions, getCartCount, getContextDisplayCharges, getIfGiftCardApplied,
    getTotalRewardAmount,
} from '../../Cart-Selectors';

import { workerRecalculateGiftCardTotal } from '../../../Payment/GiftCard/GiftCard-Operations';
import { calculateCartComplete, clearCalculateShippingAttempt } from '../../../Payment/CalculateCart/CalculateCart-Actions';
import { workerCalculateCart } from '../../../Payment/CalculateCart/CalculateCart-Operations';

import { flagOffShowLoadingMessage, updateShowLoadingMessage } from '../../../../../Common/ducks/ShowLoadingMessage/ShowLoadingMessage-Actions';
import { getDeliveryDateSelectionsSalesForceABTest, getFeatureFlags, getOnePageCheckoutSaleForceABTest } from '../../../App/App-Selectors';
import { continueToPayment, getOrderId } from '../../../../../Checkout/ducks/Common/Common-Selectors';
// TODO: add prepare cart when the error handler for the new apis is done
import { callPrepareCartCompleted } from '../../Cart-Actions';
import { workerPrepareCart } from '../../Cart-Operations';

export function* prepareRetreiveCart(page) {
    try {
        yield put(updateShowLoadingMessage());
        const isGiftCardApplied = yield select(getIfGiftCardApplied);
        const cartPromotions = yield select(getAppliedPromotions);
        const flagState = yield select(getFeatureFlags);
        const isShippingEstimated = flagState['is-estimated-shipping-enabled'] || false;
        const isShippingEstimatedPaymentPage = flagState['is-estimated-shipping-payment-page-enabled'] || false;
        const isDynamicPassportApiEnabled = flagState['is-dynamic-passport-api-enabled'] || false;
        const cartCount = yield select(getCartCount);
        const contextDisplayCharges = yield select(getContextDisplayCharges);
        const totalRewardAmount = yield select(getTotalRewardAmount);

        const deliveryDateSelectionsSFABTest = yield select(getDeliveryDateSelectionsSalesForceABTest);
        const isMultiOptionDeliveryEnabled = deliveryDateSelectionsSFABTest === 'Default';

        const onePageCheckout = yield select(getOnePageCheckoutSaleForceABTest) || {};
        const isOnePageCheckoutEnabled = flagState['is-one-page-checkout-enabled'] === 'newflow'
            || (
                flagState['is-one-page-checkout-enabled'] === 'salesforce'
                && onePageCheckout?.campaign?.campaignResponses?.[0]?.userGroup === 'Default'
            );

        // This only trigger the first time you are in shipping page
        if (page === 'startShipping' || (page === 'single-shipping-payment')) {
            yield fork(workerPrepareCart);
            yield take(callPrepareCartCompleted().type);
        }

        if (
            ['review-order', 'payment-review', 'review'].includes(page)
            || (
                ['payment'].includes(page)
                && isShippingEstimatedPaymentPage
            )
            || (
                ['startShipping', 'shipping'].includes(page)
                && isShippingEstimated
                && cartCount > 0
            )
            || Number(totalRewardAmount) > 0
            || isOnePageCheckoutEnabled
            || contextDisplayCharges
            || isMultiOptionDeliveryEnabled
            || (
                isGiftCardApplied || cartPromotions?.length > 0
            )
        ) {
            const payload = {};

            if (
                isMultiOptionDeliveryEnabled
                && ['startShipping', 'shipping'].includes(page)
                && !isShippingEstimated
            ) {
                payload.calcode = 'SHIPPING';
            }

            yield put(clearCalculateShippingAttempt());
            yield fork(workerCalculateCart, payload);
            yield take(calculateCartComplete().type);
            if (isDynamicPassportApiEnabled) {
                yield put(getCalculateDynamicPassport());
            }
            if (isGiftCardApplied || cartPromotions?.length > 0) {
                yield call(workerRecalculateGiftCardTotal);
            }
        }
    } catch (ex) {
        yield put(flagOffShowLoadingMessage());

        const orderId = yield select(getOrderId);
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            function: 'prepareRetreiveCart',
            jsError: ex,
            message: 'Error occured while prepareRetreiveCart',
            orderId,
        });
    }
}

export default {};
